module.exports = __webpack_public_path__ + "img/telegram.800ba63.png";